<template>
  <div class="container">
    <div class="w1200">
      <h3><span>—</span>{{!sysName|| sysName === 'null'   ? "外文学术资源数据库" : sysName}}
        <span>—</span>
      </h3>
      <div class="search flex">
        <div>
          <div class="flex search_div">
            <el-select
              v-model="value"
              class="title-select"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="searchLeft flex">
              <el-select
                v-model="selectVal"
                v-if="value == 1"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in routerName == 'article'
                    ? searchPaperOptions
                    : searchOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="inputDiv flex">
                <el-input
                  v-model="keyword"
                  clearable
                  @keyup.enter.native="toSearch"
                  :placeholder="placeholderName()"
                ></el-input>
                <img src="../assets/images/search.png" @click="toSearch" />
              </div>
            </div>
            <a @click="toHightSearch">高级检索</a>
          </div>
        </div>
      </div>
      <div class="search_nav" v-if="routerName == 'article'">
        当前位置：首页
      </div>
    </div>
  </div>
</template>

<script>
import urlobj from "@/api/baseurl.js";
export default {
  name: "search",
  data() {
    return {
      value: 1,
      options: [
        {
          value: 1,
          label: "分词检索",
        },
        {
          value: 2,
          label: "智能检索",
        },
      ],
      searchOptions: [
        { label: "全部", value: null },
        { label: "刊名", value: "name" },
        { label: "ISSN", value: "issn" },
        { label: "出版社", value: "publisherName" },
      ],
      searchPaperOptions: [
        { label: "全部", value: null },
        { label: "题名", value: "title" },
        { label: "DOI", value: "doi" },
        { label: "作者", value: "author" },
        { label: "作者机构", value: "authorOrg" },
        { label: "关键词", value: "hingeWord" },
        // { label: "摘要", value: "digest" },
      ],
      selectVal: null,
      keyword: "",
      list: ["全部", "商业资源", "OA资源", "本馆资源"],
      radio: require("../assets/images/radio.png"),
      radioChecked: require("../assets/images/radio_checked.png"),
      routerName: "",
      sysName: "",
    };
  },
  mounted() {
    if (localStorage.getItem("sysName")) {
      this.sysName = localStorage.getItem("sysName");
    } else if (localStorage.getItem("systemName")) {
      this.sysName = localStorage.getItem("systemName");
    }
    this.routerName = this.$route.name;
  },
  methods: {
    placeholderName() {
      if (this.value == 2) {
        return "支持自然语言（语义）检索";
      } else {
        if (this.routerName == "article") {
          return "请输入题名、DOI、作者、作者机构、基金项目";
        } else {
          return "请输入刊名、ISSN、出版社";
        }
      }
    },
    toHome() {
      sessionStorage.removeItem("heightSearchWord");
      this.$router.replace({ path: "/" });
    },
    toSearch() {
      let json = {
        keyword: this.keyword,
        selectVal: this.selectVal,
      };
      this.$emit("childBySearch", json);
    },
    toHightSearch() {
      if (this.routerName == "article") {
        this.$router.push({ path: "/search", query: { type: "article" } });
      } else {
        this.$router.push({ path: "/search", query: { type: "home" } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 240px;
  background: url("../assets/images/search_bg.png") no-repeat;
  .w1200 {
    padding-top: 40px;
    position: relative;
    height: 100%;
    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      font-family: "宋体";
      span {
        color: #cccccc;
      }
    }
    .search {
      align-items: center;
      justify-content: center;
      .search_div {
        align-items: center;
        margin-top: 30px;
        margin-bottom: 15px;
        a {
          font-size: 18px;
          text-decoration: underline;
          &:hover {
            text-decoration: underline;
          }
        }
        .title-select {
          width: 120px;
          margin-right: 10px;
          ::v-deep .el-input__inner {
            height: 52px;
            border: 1px solid #ccc;
            border-radius: 0;
          }
        }
      }
      .searchLeft {
        border: 1px solid #cccccc;
        width: 640px;
        height: 52px;
        background: #fff;
        position: relative;
        ::v-deep .el-input__inner {
          border: none;
          height: 52px;
          background: none;
          border-radius: 0;
        }
        .el-select {
          position: relative;
          width: 110px;
          &::after {
            content: "";
            position: absolute;
            right: -2px;
            top: 50%;
            margin-top: -12px;
            width: 1px;
            height: 24px;
            background: #cccccc;
            background: #006eb2;
          }
        }
        .inputDiv {
          align-items: center;
          flex: 1;
          background: #fff;
          ::v-deep .el-input {
            flex: 1;
          }
        }
        img {
          width: 22px;
          height: 24px;
          cursor: pointer;
          margin-right: 20px;
        }
      }
      a {
        color: #2d8cf0;
        margin-left: 10px;
      }
    }
    .search_nav {
      color: #999999;
      font-size: 14px;
      position: absolute;
      left: 0;
      bottom: 10px;
    }
    .item {
      padding-left: 15px;
      li {
        display: flex;
        align-items: center;
        margin-right: 30px;
        cursor: pointer;
        color: #666666;
        font-size: 14px;
        img {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>